import { create } from 'zustand';

interface FeedTitlesState {
  titles: Record<string, string>;
  setTitle: (url: string, title: string) => void;
}

// In-memory only — populated by useOpdsFeed as the user navigates, and
// read by Breadcrumbs to render localized labels for visited levels.
// Not persisted: titles are cheap to repopulate on the first fetch and
// localization can change between sessions.
export const useFeedTitles = create<FeedTitlesState>((set) => ({
  titles: {},
  setTitle: (url, title) =>
    set((state) =>
      state.titles[url] === title
        ? state
        : { titles: { ...state.titles, [url]: title } }
    ),
}));
